import {ModuleFc} from '@/project'
import {removeItem, updateAll, updateObject} from '@/store/utils'
import {Certificate, CertificateState, RequestCodePayload} from './types'

export {CertificateState, Certificate}

const module: ModuleFc<CertificateState> = (ctx) => ({
  namespaced: true,
  state: {
    certificates: [],
    isRequiredPopup: true
  },
  actions: {

    async getCertificates({commit, rootState}, payload: { bizId?: string } = {}) {
      const result = await ctx.$axios({
        url: '/certificates',
        method: 'get',
        data: {
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
        },
      })
      commit('update', result.data.results)
    },
    async removeCertificate({commit, rootState, dispatch}, payload: {
      id?: string, bizId?: string,
    } = {}) {
      const {id} = payload
      await ctx.$axios({
        url: '/certificates/$bizId',
        method: 'delete',
        data: {
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
          id,
        },
      })
      dispatch('auth/getUser', {}, {root: true})
      commit('remove', id)
    },
    async getRegisterCode({rootState}, payload: {
      bizId?: string, services?: RequestCodePayload[]} = {}
    ) {
      const {services = []} = payload
      const result = await ctx.$axios({
        url: '/certificates/code/$id',
        method: 'post',
        data: {
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
          thirdPartyServices: services,
        },
      })
      return result.data.code
    },
  },
  mutations: {
    update(state, payload: Certificate[]) {
      updateAll(state.certificates, payload)
    },
    remove(state, id: string) {
      removeItem(state.certificates, {id})
    },
    clear(state, payload = []) {
      state.certificates = payload
      state.isRequiredPopup = true
    },
    updateRequiredPopup(state, requiredPopup: boolean) {
      updateObject(state, {isRequiredPopup: requiredPopup})
    }
  },
})

export default module
